var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41_1895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 0C4.92492 0 0 4.92492 0 11C0 16.1586 3.55168 20.4873 8.34284 21.6762V14.3616H6.07464V11H8.34284V9.55152C8.34284 5.80756 10.0373 4.0722 13.713 4.0722C14.41 4.0722 15.6125 4.20904 16.1044 4.34544V7.39244C15.8448 7.36516 15.3938 7.35152 14.8337 7.35152C13.0302 7.35152 12.3332 8.03484 12.3332 9.81112V11H15.9262L15.3089 14.3616H12.3332V21.9195C17.78 21.2617 22.0004 16.6241 22.0004 11C22 4.92492 17.0751 0 11 0Z",
    fill: "white",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41_1895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.b5ff61b245ade8cdeae296398b44f30f.svg";
export { ForwardRef as ReactComponent };